import { render, staticRenderFns } from "./OtherStockDocumentPage.vue?vue&type=template&id=079b70d5&scoped=true"
import script from "./OtherStockDocumentPage.vue?vue&type=script&lang=js"
export * from "./OtherStockDocumentPage.vue?vue&type=script&lang=js"
import style0 from "./OtherStockDocumentPage.vue?vue&type=style&index=0&id=079b70d5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "079b70d5",
  null
  
)

export default component.exports